import { useState } from "react";
import denyChangeTicketRequest from "../../controllers/booking/postTicketing/change/denyChangeTicketRequest";
import { enqueueSnackbar } from "notistack";
import Button1 from "../form/Button1";
import { Modal3 } from "../DIsplay/Modal/Modal3";
import TextInput from "../form/TextInput";
import { getOrderManagementId } from "../../utils/task/taskUtilFun";

function DeclineTask({ data, openDenyChange, setOpenDenyChange, setAffect }) {
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");

  const orderManagementId = getOrderManagementId(data);

  const handleDenyChange = async () => {
    setLoading(true);
    const reqBody = {
      rejectReason: reason,
    };
    const res = await denyChangeTicketRequest(orderManagementId, reqBody);
    setLoading(false);
    if (res.return) {
      enqueueSnackbar("Request has been denied.", { variant: "success" });
      setReason("");
      setAffect((prev) => prev + 1);
      setOpenDenyChange(false);
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
    }
  };

  return (
    <Modal3
      open={openDenyChange}
      setOpen={setOpenDenyChange}
      title={"Decline Ticket Re-issue Request"}
    >
      <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
        {/* <h5>What's your reson?</h5> */}
        <TextInput
          label="Reamrk"
          multiline
          rows={5}
          placeholder={"e.g. Ticket not available"}
          value={reason || ""}
          onChange={(ev) => setReason(ev.target.value)}
        />
        <div className="flex justify-end items-center gap-4">
          <div>
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenDenyChange(false)}
            >
              Cancel
            </Button1>
          </div>
          <Button1 onClick={() => handleDenyChange(data)} loading={loading}>
            Continue
          </Button1>
        </div>
      </div>
    </Modal3>
  );
}

export default DeclineTask;
